// A component that will conditional render its children.
// This was made for usage with the campaign engine.

const RenderChildren = ({ renderChildren, children }) => {
  return renderChildren ? children : null;
};

export default RenderChildren;
